import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1367632915547845';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const n: any = w.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init failed:', err);
    }
  }, []);
  return <div className="min-h-screen bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="3dmfn1j59sjkv">
      <main data-id="element-1" data-mp="nvarfq9f9dfl">
        <Hero data-id="element-2" data-mp="nxn5hsc273nd" />
        <TestimonialsStrip data-id="element-3" data-mp="sunas11342df" />
        <PainPoints data-id="element-4" data-mp="stuclog6yl6w" />
        <SolutionReveal data-id="element-5" data-mp="stc7017n2umb" />
        <TomosSection data-id="element-6" data-mp="swqaxdvybbvv" />
        <BonusSection data-id="element-7" data-mp="36hzjfpzb85g" />
        <PricingSection data-id="element-8" data-mp="35ox2qy1z4t4" />
        <ExtendedTestimonials data-id="element-9" data-mp="34x1hg4gh72u" />
        <Guarantee data-id="element-10" data-mp="38b6yx8f1wei" />
        <FAQ data-id="element-11" data-mp="3ud1f186rfma3" />
        <FinalCTA data-id="element-12" data-mp="3udkos1m9b4d1" />
      </main>
      <Footer data-id="element-13" data-mp="3uc9jfxd5xojt" />
      <PurchaseNotifications data-id="element-14" data-mp="3uevs60bsia3m" />
      <noscript data-id="element-15" data-mp="d4e4fpsbp6v4">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-16" data-mp="d4xopd5g47cb" />
      </noscript>
    </div>;
}